var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12793 6.36694H23.9424V8.48906H6.12793V6.36694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45801 3H21.6181V4.76837H8.45801V3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81445 10.6111V22.7559C3.81445 23.8815 4.26162 24.9611 5.05748 25.7569C5.85334 26.5528 6.93282 27 8.05847 27H21.9575C23.0832 27 24.1626 26.5528 24.9585 25.7569C25.7543 24.9611 26.2015 23.8814 26.2015 22.7559V10.6111H3.81445ZM15.1317 22.2819H15.1316C14.6161 22.7986 13.9164 23.0889 13.1864 23.0889C12.4567 23.0889 11.7567 22.7986 11.2413 22.2819L8.9283 19.976L10.4278 18.4765L12.7407 20.7895C12.8601 20.9083 13.0217 20.975 13.1899 20.975C13.3583 20.975 13.5199 20.9083 13.639 20.7895L19.5876 14.8336L21.0871 16.3331L15.1317 22.2819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.ecb76fa9bec9b1c2b9722356e0597f8c.svg";
export { ForwardRef as ReactComponent };